<template>
  <div class="list-page">
	<Header></Header> <!-- 头部 -->
	<div class="content" style="min-height: 600px;">
		<van-cell-group class="subform">
			<van-cell title="申请人" :value="ADMIN.USER_NAME"/>
			<van-cell title="所属部门" :value="ADMIN.USER_DEPARTMENT_NAME" />
			<van-cell title="假期剩余" :value="policy_date" />
			<van-cell class="required-x" title="请假类型" is-link arrow-direction="down" :value="policy_category" @click="onSelectPolicy()" />
			<van-cell class="required-x" title="开始时间" is-link arrow-direction="down" :value="start_date" @click="onSelectDate(1)" />
			<van-cell class="required-x" title="结束时间" is-link arrow-direction="down" :value="end_date" @click="onSelectDate(2)" />
			<van-cell title="工作交接人" class="required-x t-input">
				<van-field 
					name="search_name"
				    placeholder=""
					id="js-user"
					v-model="search_name"
					@input="onInputShow('js-user')"
				/>
			</van-cell>
			<!-- 用户隐藏框 -->
			<div class="search_show search_user van-cell">
				<div class="van-cell__title"><span></span></div>
				<div class="van-cell__value">
				</div>
			</div>
			<!-- <van-cell title="工作交接人" class="t-input required-x">
				<van-field 
				    name="jjname"
				    placeholder=""
					v-model="jjname"
				/>
			</van-cell>-->
			<!-- <van-picker :columns="policy_list" @change="onChange" /> -->
			<van-cell title="请假原因" class="last">
				<van-cell-group>
				  <van-field
					class="textarea"
					rows="2"
					v-model="reason"
					type="textarea"
					id="reason"
				  />
				</van-cell-group>
			</van-cell>
			<van-cell id="attach-show" title="上传附件" class="last required-x" style="display:none;">
				<!-- <van-uploader name="uploadFile" :max-count="1" v-model="fileList" :after-read="afterFiles" /> -->
				<van-uploader name="uploadFile" multiple v-model="fileList" :after-read="afterFiles" :before-delete="deleteFiles" />
			</van-cell>
			
			<div class="text-center btn-submit fixed bottom60" style="z-index:999;">
				<van-button @click="onSubmit()" type="info" size="large">提交</van-button>
			</div>
			<van-popup v-model="is_start_date_show" position="bottom" :style="{ height: '40%' }">
			  <van-datetime-picker 
			  v-model="start_currentDate" 
			  type="datetime" 
			  :min-date="minDate"
			  :max-date="maxDate"
			  @change="OnChangeDate()" 
			  @confirm="OnConfirmDate()" 
			  @cancel="OnCancelDate()" />
			</van-popup>
			<van-popup v-model="is_end_date_show" position="bottom" :style="{ height: '40%' }">
			  <van-datetime-picker 
			  v-model="end_currentDate" 
			  type="datetime" 
			  :min-date="minDate"
			  :max-date="maxDate"
			  @change="OnChangeDate()" 
			  @confirm="OnConfirmDate()" 
			  @cancel="OnCancelDate()" />
			</van-popup>
			<van-popup v-model="is_policy_show" position="bottom" @click="onSelectPicker">
			  <van-picker
			    show-toolbar
			    visible-item-count="1"
			    :columns="policy_list"
			    @change="onConfirmPolicy"
			  />
			</van-popup>
	</van-cell-group>
	<Footer></Footer> <!-- 尾部 -->
	</div>
  </div>
</template>
<style lang="less">
	.van-cell__title{max-width: 22%;}
	.van-cell__value{text-align: left;}
	.last.van-cell:not(:last-child)::after{border-bottom:none;}
</style>
<script type="text/javascript">
import axios from 'axios';
export default {
    created() {
		this.getPolicyCategory();//获取假期类型
		let post_data = new FormData();
		var str_json_data = '{"type":"2","types":"","beginTime":"","endTime":"","number":"'+this.ADMIN.USER_CODE+'"}';
		post_data.append("param",str_json_data);
		axios.post(this.CoreNew.OA_API_IP+"joa-business/ehr/getLeaveParam/",post_data,{
			headers: {
					'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))
				}
		}).then(function (response) {
			this.policy_data_list=JSON.parse(response.data.data);
			for (var i=0;i<this.policy_data_list.length;i++){
			    var $days_list=this.policy_data_list[i];
				if($days_list.name=="年假"){
					this.policy_date=$days_list.remainlimit;
					break;
				}
			}
			//console.log(this.policy_data_list[0].name)
		}.bind(this)).catch(function (error) { 
			//alert("请求EHR--获取员工假期--失败"+error);
			this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求EHR--获取员工假期--失败"+error);//记录错误
			console.log("请求EHR--获取员工假期--失败"+error);
		}); 
    },
	data() {
		return {
		 ADMIN:JSON.parse(localStorage.getItem('LS_ADMIN')),
		 is_date_type:1,
		 start_date:"",
		 end_date:"",
		 minDate: new Date(2020, 0, 1),
		 maxDate: new Date(2026, 12, 1),
		 start_currentDate: new Date(),
		 end_currentDate: new Date(),
		 is_start_date_show: false,
		 is_end_date_show: false,
		 is_policy_show:false,
		 policy_list: [],
		 policy_category:'年假',
		 policy_date:0,
		 policy_data_list:[],
		 days_lists:{},
		 search_name: "",
		 jjname:"",//工作交接人
		 reason:"",//请假理由
		 files:[],//提交的文件
		 fileList: []
		 /*fileList: [
			 { url: 'https://img.yzcdn.cn/vant/leaf.jpg' },
			 { url: 'https://cloud-image', isImage: true }
		 ]*/
		};
    },	
    methods: {
		getPolicyCategory: function () {
			let post_data = new FormData();
			var str_json_data = '{"type":"4","types":"","beginTime":"","endTime":"","number":"'+this.ADMIN.USER_CODE+'"}';
			post_data.append("param",str_json_data);
			axios.post(this.CoreNew.OA_API_IP+"joa-business/ehr/getLeaveParam/",post_data,{
				headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
			}).then(function (response) {
				var p_lists=JSON.parse(response.data.data);
				this.policy_list = p_lists.lx.split(","); //字符分割
				/*for (var i=0;i<this.p_lists.length;i++){
				    this.policy_list=this.policy_list.concat($p_lists);
				}*/
			}.bind(this)).catch(function (error) { 
				//alert("请求EHR--获取假期类型--失败"+error);
				this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求EHR--获取假期类型--失败"+error);//记录错误
				console.log("请求EHR--获取假期类型--失败"+error);
			}); 
		},
		onConfirmPolicy: function (picker, value, index) {
			this.policy_date=0;
			this.policy_category=value;
			this.is_policy_show = false;
			if(this.policy_category=="病假" || this.policy_category=="婚假" || this.policy_category=="产假" || this.policy_category=="陪产假" || this.policy_category=="上海婚假" || this.policy_category=="产检假"){
				$("#attach-show").show();
			}else{
				$("#attach-show").hide();
			}
			for (var i=0;i<this.policy_data_list.length;i++){
			    var $days_list=this.policy_data_list[i];
				if($days_list.name==value){
					this.policy_date=$days_list.remainlimit;
					break;
				}
			}
			//Toast(`当前值：${value}, 当前索引：${index}`);
		},
		onSelectPolicy: function () {
			this.is_policy_show = true;
		},
		onSelectPicker: function () {
			this.is_policy_show = false;
		},
		onSelectDate: function (i) {
			if(i==2){
				this.is_date_type=2;this.is_start_date_show = false;
				this.is_end_date_show = true;
			}else{
				this.is_date_type=1;this.is_end_date_show = false;
				this.is_start_date_show = true;
			}
		},
		OnChangeDate: function () {
			//this.changeDate = this.currentDate ;
		},
		OnConfirmDate: function () {
			if(this.is_date_type==2){
				this.end_date = this.GetTimeFormat(this.end_currentDate);
			}else{
				this.start_date = this.GetTimeFormat(this.start_currentDate);
			}
			this.is_start_date_show = false;this.is_end_date_show = false;
		},
		OnCancelDate: function () {
			this.is_start_date_show = false;this.is_end_date_show = false;
		},
		GetTimeFormat: function (time) {// 时间格式化 2019-09-08
		   let y = time.getFullYear();
		   let MM = time.getMonth() + 1;
		   MM = MM < 10 ? ('0' + MM) : MM;
		   let d = time.getDate();
		   d = d < 10 ? ('0' + d) : d;
		   let h = time.getHours();
		   h = h < 10 ? ('0' + h) : h;
		   let m = time.getMinutes();
		   m = m < 10 ? ('0' + m) : m;
		   //let s = time.getSeconds()<10 ? "0"+time.getSeconds() : time.getSeconds();
		   return y + '-' + MM + '-' + d + ' '+ h + ':' + m;
		},
		finish: function () {
			$(".sms-no").hide();
			$(".sms-yes").show();
			this.$refs.countDown.reset();
		},
		getTime:function(){
			var _this = this;
		    let yy = new Date().getFullYear();
		    let mm = new Date().getMonth()+1;
		    let dd = new Date().getDate();
		    let hh = new Date().getHours();
		    let mf = new Date().getMinutes()<10 ? "0"+new Date().getMinutes() : new Date().getMinutes();
		    let ss = new Date().getSeconds()<10 ? "0"+new Date().getSeconds() : new Date().getSeconds();
		    return yy+"-"+mm+"-"+dd;
		},
		afterFiles:function(file){
			//this.files=file.file;
			this.files=this.files.concat(file.file);
			//console.log(this.files);
			//var $arr=[];
			//$arr=file.file.name.split(".");
			//this.files["name"]=	$arr[0];
			//this.files["type"]=$arr[1];
			//this.files["content"]=file.content;
		},
		deleteFiles:function(file,name){
			this.files.splice(name.index,1);
			return Promise;
		},
		onBlurShow: function (id) {
			$(".search_show").hide();
		},
		onInputShow: function (id) {
			$(".search_user .van-cell__value").find(".input_show").remove();
			if(this.search_name!=""){
				axios.get(this.CoreNew.OA_API_IP+"joa-business/commonQuery/simpleUserQuery?limit=1200&keyword="+this.search_name,{
					headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
				}).then(function (response) {
					var $rs=response.data;var str_html="";
					if($rs.flag==true){
						$(".search_show").show();
						var $list=$rs.data;var _str_html
						for (var i = 0; i < $list.length; i++) {
							str_html +="<li data-val='"+$list[i].code+"'>"+$list[i].cname+"</li>";
						}
						$(".search_user .van-cell__value").find(".input_show").remove();
						$(".search_user .van-cell__value").append('<ul class="input_show">'+str_html+'</ul>');
						$(".search_user .van-cell__value").find(".input_show").show();
						var self = this;
						$(".search_user").find(".input_show li").click(function(){
							self.search_name=$(this).html();
							self.jjname=$(this).attr("data-val");
							$(".search_show").hide();
						})
					}else{
						$(".search_show").hide();
					}
				}.bind(this)).catch(function (error) { 
					//alert("请求--用户搜索--失败"+error);
					this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--用户搜索--失败"+error);//记录错误
					console.log("请求--用户搜索--失败"+error);
				});
			}
		},
		onSubmit: function () {
			$(".search_show").hide();
			if(this.start_date == ''){
				this.$toast("开始时间不能为空"); return false; 
			} 
			if(this.end_date == ''){
				this.$toast("结束时间不能为空"); return false; 
			} 
			if(this.start_date > this.end_date){
				this.$toast("结束时间不能小于开始时间"); return false; 
			}
			if(this.jjname == ''){
				if($("input[name='search_name']").val()!=""){
					this.$toast("请选择正确的工作交接人"); return false;
				}else{
					this.$toast("工作交接人不能为空"); return false;
				} 
			}
			if((this.policy_category=="病假" || this.policy_category=="婚假" || this.policy_category=="产假" || this.policy_category=="陪产假" || this.policy_category=="上海婚假" || this.policy_category=="产检假") && this.files.length==0){
			//if(this.policy_category=="病假" && this.files.length==0){
				this.$toast("附件还没上传"); return false;
			}
			//提交
			$("#loading").show();
			let post_data = new FormData(); 
			var upload_attache=[];
			if(this.policy_category=="病假" && this.files.length>0){
				var str_json_data = '{"timeOffApplyType":"'+this.policy_category+'","personNum":"'+this.ADMIN.USER_CODE+'","timeOffStartDate":"'+this.start_date+'","timeOffEndDate":"'+this.end_date+'","excuse":"'+this.reason+'","jjname":"'+this.jjname+'"}';
				post_data.append("param",str_json_data);
				for (var i = 0; i < this.files.length; i++) { 
					post_data.append("files"+(i+1),this.files[i]);
				}
				//post_data.append("files",this.files);
			}else{
				var str_json_data = '{"timeOffApplyType":"'+this.policy_category+'","personNum":"'+this.ADMIN.USER_CODE+'","timeOffStartDate":"'+this.start_date+'","timeOffEndDate":"'+this.end_date+'","excuse":"'+this.reason+'","jjname":"'+this.jjname+'","fileType":"","fileName":""}';
				post_data.append("param",str_json_data);
			}
			axios.post(this.CoreNew.OA_API_IP+"joa-ws/ehr/saveLeaveBillFiles/",post_data,{
			//axios.post(this.CoreNew.OA_API_IP+"joa-business/ehr/saveLeaveBillFiles/",post_data,{
				headers: {
					'Content-Type': 'multipart/form-data',
					//'Content-Type': this.files["type"],
					'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))
				}
			}).then(function (response) {
				var $rs=JSON.parse(response.data.data);
				$("#loading").hide();
				if(response.data.flag==true && $rs.msg.indexOf("成功")==0){
					this.$toast("操作成功");
					var time = 2;
					var timer = setInterval(function() {
						time--;
						if(time == 0) {
							window.location.href=JSON.parse(localStorage.getItem('LS_WEB_URL'))+'apply?sys=ehr';
							clearInterval(timer);//清楚定时
						}
					}, 1000);
				}else{
					this.$toast($rs.reson);
				}
			}.bind(this)).catch(function (error) { 
				//alert("请求EHR--保存请假--失败"+error);
				this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求EHR--保存请假--失败"+error);//记录错误
				console.log("请求EHR--保存请假--失败"+error);
			});
		}
    }
};
</script>